{
  "back": "뒤로",
  "form": "양식",
  "purposeTitle": "이번 방문의 목적은 무엇인가요?",
  "appointmentInfoTitle": "예약 정보",
  "appointmentInfoHint": "예약이 있는 경우 이 필드를 반드시 입력하세요.",
  "checkInDetailsTitle": "체크인 세부 정보",
  "checkInDetailsHint": "방문에 대한 추가 정보입니다.",
  "driverPhoneLabel": "운전자 전화번호",
  "activateWhatsAppTitle": "WhatsApp 메시지 활성화",
  "activateWhatsAppBody": "창고와 채팅하려면 첫 번째 WhatsApp 메시지를 받으면 \"OK\"라고 답장하세요.",
  "whatsappDelayBanner": "첫 번째 WhatsApp 메시지가 도착하는 데 최대 1분이 걸릴 수 있습니다.",
  "notesLabel": "메모",
  "notesPlaceholder": "시설에 전달할 특별 지침이나 메모가 있나요?",
  "verifyAndCheckIn": "확인 후 체크인",
  "completeCheckIn": "체크인 완료",
  "visitGroupInbound": "입고",
  "visitGroupOutbound": "출고",
  "visitGroupBoth": "입고 및 출고",
  "visitUnloadTruck": "내 트럭 하차",
  "visitDropTrailer": "내 트레일러 또는 컨테이너 분리",
  "visitLoadTruck": "내 트럭 상차",
  "visitHookTrailer": "트레일러 또는 컨테이너 연결",
  "visitUnloadLoad": "내 트럭 하차 및 상차",
  "visitDropHook": "트레일러 또는 컨테이너 분리 및 연결",
  "containerTrailer": "트레일러",
  "containerContainer": "컨테이너",
  "containerOversized": "특대형",
  "containerOther": "기타",
  "defaultReferenceName": "구매 주문 번호(PO Number)",
  "identifierSuffix": "{reference} 또는 확인 번호",
  "licenseOrDotRequired": "번호판 또는 DOT 번호를 입력하세요",
  "appointmentNotFound": "예약을 찾을 수 없습니다",
  "referenceNotFound": "일치하는 예약이 없습니다. 참조 번호는 대소문자를 구분합니다.",
  "referenceCaseSensitiveHint": "참조 번호는 대소문자를 구분합니다",
  "messaging": {
    "whatsappFailedTitle": "WhatsApp 메시지를 보낼 수 없습니다",
    "smsFailedTitle": "SMS 메시지를 보낼 수 없습니다",
    "whatsappFailedBody": "{displayPhone}(으)로 메시지를 보낼 수 없습니다. <br /><br /> 이전에 수신 거부한 경우, 이 창고의 메시지를 다시 받으려면 <a href='{waUrl}' target='_blank' rel=\"noopener noreferrer\">{senderPhone}</a>(으)로 START를 보내세요.",
    "smsFailedBody": "{displayPhone}(으)로 메시지를 보낼 수 없습니다. <br /><br /> 이전에 수신 거부한 경우, 이 창고의 SMS 메시지를 다시 받으려면 <a href='{smsUrl}'>{senderPhone}</a>(으)로 START를 보내세요.",
    "fallbackPhone": "입력한 전화번호"
  }
}
